import actionTypes from '@/core/constants/action-types'
import LacunaWebPki from 'web-pki'

export default class AzDigitalSignature {
    constructor({ store, licencaLacuna, pki }) {
        this.store = store

        if (pki) {
            this.pki = pki
        } else if (licencaLacuna) {
            this.pki = new LacunaWebPki(licencaLacuna)
        }
    }

    async loadWebPki() {
        return new Promise((resolve, reject) => {
            this.pki.init({
                ready: () => resolve(true),
                notInstalled: () => resolve(false),
                defaultError: message => reject(message),
            })
        })
    }

    async listCertificates() {
        return new Promise((resolve, reject) => {
            this.pki
                .listCertificates()
                .success(certificates => {
                    const formatedCertificates = this._formatCertificatesTitles(
                        certificates
                    )
                    resolve(formatedCertificates)
                })
                .error(error => reject(error))
        })
    }

    async sign(
        certificateThumbPrint,
        documentId,
        rubricBase64 = null,
        participation = null
    ) {
        const certificateContent = await this._readCertificate(
            certificateThumbPrint
        )
        const paramsToSign = await this._preprareDocumentToSign(
            certificateContent,
            documentId
        )
        const signHash = await this._sign({
            thumbprint: certificateThumbPrint,
            hash: paramsToSign.hashParaAssinar,
            algorithm: paramsToSign.algoritmoHash,
        })
        return await this._finishSign(
            documentId,
            signHash,
            paramsToSign,
            rubricBase64,
            participation
        )
    }

    redirectToInstallWebPki() {
        this.pki.redirectToInstallPage()
    }

    async _finishSign(
        documentId,
        signHash,
        paramsToSign,
        rubricBase64,
        participation
    ) {
        return await this.store.dispatch(
            actionTypes.DOCUMENTO.FINALIZAR_ASSINATURA_DIGITAL,
            {
                documentId,
                signHash,
                temporarySubscription: paramsToSign.assinaturaTemporariaId,
                rubricBase64,
                participation,
            }
        )
    }

    async _preprareDocumentToSign(certificateContent, documentId) {
        return this.store.dispatch(
            actionTypes.DOCUMENTO.INICIAR_ASSINATURA_DIGITAL,
            {
                certificateContent,
                documentId,
            }
        )
    }

    async _readCertificate(thumbprint) {
        return new Promise((resolve, reject) => {
            this.pki
                .readCertificate(thumbprint)
                .success(informacoesPublicas => resolve(informacoesPublicas))
                .error(error => reject(error))
        })
    }

    async _sign({ thumbprint, hash, algorithm }) {
        return new Promise((resolve, reject) => {
            this.pki
                .signHash({
                    thumbprint,
                    hash,
                    digestAlgorithm: algorithm,
                })
                .success(signatureHash => resolve(signatureHash))
                .error(error => reject(error))
        })
    }

    _formatCertificatesTitles(certificados) {
        certificados.forEach(certificado => {
            if (new Date() > certificado.validityEnd) {
                certificado.prettyName = `[EXPIRADO] ${certificado.subjectName} (emitido por ${certificado.issuerName})`
            } else {
                certificado.prettyName = `${certificado.subjectName} (emitido por ${certificado.issuerName})`
            }
        })
        return certificados
    }
}
